// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1RVJZ","Label":"BuildControl_Label__2LXSb","Less":"BuildControl_Less__3cszP","More":"BuildControl_More__3BYfT"};